import type { RouteRecordRaw } from 'vue-router'
import { MY_ROUTES } from '@/router/routes.enum'
import { requireAuthenticated } from '@/router/guards'

export const accountRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/my/modules/account/views/AccountBase.view.vue'),
    redirect: '/orders',
    children: [
      {
        path: 'orders',
        name: MY_ROUTES.ORDERS,
        beforeEnter: requireAuthenticated,
        component: () => import('@/my/modules/orders/views/OrderListing.view.vue')
      },
      {
        path: '/account',
        name: MY_ROUTES.ACCOUNT,
        beforeEnter: requireAuthenticated,
        component: () => import('@/my/modules/account/views/PersonalPreferences.view.vue')
      },
      {
        path: 'security',
        name: MY_ROUTES.SECURITY,
        beforeEnter: requireAuthenticated,
        component: () => import('@/my/modules/account/views/SecuritySettings.view.vue')
      },
      {
        path: 'trip_cards',
        children: [
          {
            path: '',
            name: MY_ROUTES.TRIP_CARDS,
            beforeEnter: [requireAuthenticated],
            component: () => import('@/my/modules/trip-cards/views/TripCards.view.vue')
          },
          {
            path: ':id/balance',
            name: MY_ROUTES.TRIP_CARD_BALANCE_HISTORY,
            beforeEnter: [requireAuthenticated],
            component: () => import('@/my/modules/trip-cards/views/TripCardBalance.view.vue')
          },
          {
            path: ':id/top_ups',
            name: MY_ROUTES.TRIP_CARD_TOP_UP_HISTORY,
            beforeEnter: [requireAuthenticated],
            component: () => import('@/my/modules/trip-cards/views/TripCardTopUps.view.vue')
          }
        ]
      },
      {
        path: 'payment_methods',
        name: MY_ROUTES.PAYMENT_METHODS,
        beforeEnter: requireAuthenticated,
        component: () => import('@/my/modules/payment-methods/views/PaymentMethods.view.vue')
      }
    ]
  }
]
